import { SortState } from "shared/models/tabletReactQuery";
import { ChannelTypesState } from "shared/models/ChannelTyoes";
import { useState } from "react";
import { useSuperQuery } from "@vadiun/react-hooks-legacy";
import { channelService } from "shared/services/shared/channelService";


export const getDefaultSort = (): SortState => ({
    sortDir: 'ASC',
    sortBy: 'name'
  });


export const getDefaultState = (): ChannelTypesState => ({
    page: 1,
    rowsPerPage: 20,
    sort: getDefaultSort(),
    filters: {},
    columnVisibility: {}
  });

  export const useChannelTypes = () => {
    const ChannelService = channelService();
    const [state, setState] = useState<ChannelTypesState>(getDefaultState());
    const getChannelTypes = useSuperQuery(
        () => ChannelService.getAll(state.page, state.rowsPerPage, state.sort.sortBy, state.sort.sortDir),
        {
            showSpinner: true
        },
        [state.page, state.rowsPerPage, state.sort.sortBy, state.sort.sortDir]
    );

    return {
        channelTypes: {
            data: getChannelTypes.data?.rows || [],
            total: getChannelTypes.data?.total || 0,
            isLoading: getChannelTypes.isLoading,
            error: getChannelTypes.error,
            reload: getChannelTypes.reload,
            serverSideOptions: {
                page: state.page - 1,
                count: getChannelTypes.data?.total || 0,
                rowsPerPage: state.rowsPerPage,
                sortOrder: {
                    name: state.sort.sortBy,
                    direction: state.sort.sortDir.toLowerCase() as 'asc' | 'desc'
                }
            }
        }
    }
  }